import { PropsWithChildren, useState } from 'react'
import { Popover } from 'react-tiny-popover'
import { mdiDotsVertical } from '@mdi/js'

import { KebabMenuButton, KebabMenuIcon, KebabMenuItemsUl } from './styles'

export { default as KebabMenuItem } from './KebabMenuItem'

interface KebabMenuProps extends PropsWithChildren<{}> {
  extraStyles?: Partial<CSSStyleDeclaration>
}

export function KebabMenu({ children, extraStyles }: KebabMenuProps) {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <Popover
      isOpen={isOpen}
      positions={['bottom', 'top']}
      reposition
      content={<KebabMenuItemsUl>{children}</KebabMenuItemsUl>}
      padding={8}
      align="end"
      onClickOutside={() => setIsOpen(false)}
      containerStyle={extraStyles}
    >
      <KebabMenuButton onClick={() => setIsOpen(!isOpen)}>
        <KebabMenuIcon path={mdiDotsVertical} size={1} />
      </KebabMenuButton>
    </Popover>
  )
}
